export default "__VITE_ASSET__2rbPfBT3__"